export const CAMERA_RAY = 'cameraRay';
export const CAMERA_DRONE = 'cameraDrone';
export const CAMERA_LINE = 'cameraLine';
export const INSPECTION_POINT = 'Inspection point';
export const TRANSLATION_LINE = 'Translation line';
export const REFERENCE_LINE = 'Reference line';
export const REFERENCE_POINT = 'Reference point';
export const MOVING_POLYLINE = 'MovingPolyLine';
export const GLTF = "GLTF"
export const IMAGES_LOCATIONS_CSV = 'images_locations.csv';
export const LINE_REF = 'lineRef';
export const POINT_REF = 'pointRef';
export const POLYLINE_REF = 'polylineRef';
export const POLYGON_REF = 'polygonRef';
export const POLYLINE = 'polyline';
export const POLYGON = 'polygon';
export const POINT = 'Point';
export const MOVING_LABEL_ENTITY = 'movingLabelEntity';
export const MOVING_LABEL = 'movingLabel';
export const MOVING_LINE = 'movingLine';
export const IMAGE_POINT = 'imagePoint';
export const MESSAGE_POINT = 'messagePoint';
export const CESIUM_SPLIT_MOVED_EVENT = 'cesium:split-moved';
export const IMAGE_POINT_TARGET = 'imagePointTarget';
export const IMAGE_POINT_RAY = 'imagePointRay';
export const TEMP_IMAGE_POINT = 'tempImagePoint';
export const REPORTS = 'Reports';
export const INSPECTION = 'Inspection';
export const INFO = "Info";
export const SURVEYS = "Surveys";
export const ASSET_ID = "AssetId";
export const SPANS = "Spans";
export const DATA = "Data";
export const DEFECT_RATING = "DefectRating";
export const INSPECTIONS = "Inspections";
export const ELEMENTS = "Elements";
export const FOLDER_TREE = "FolderTree";
export const FIND_EPSG = "FindEpsg";
export const UPLOAD_IMAGES_CSV = "UploadImagesCsv";
export const ANNOTATIONS = "Annotations";
export const ASSET_VERTICAL_FIELDS = "AssetCustomFields";
export const SURVEY_VERTICAL_FIELDS = "SurveyCustomFields";
export const AI_DB = "AI_DB";
export const TASKS = "Tasks";
export const IMAGES_MODULE = "ImagesModule";
export const BRIDGE_FORM = "BridgeForm";
export const FOLDER = "Folder";
export const LOGS = "Logs";
export const IMAGE_WITH_MEASUREMENTS = "ImageWithMeasurements";
export const RECTANGLE = 'rectangle';
export const LINE = 'line';
export type MouseMode = typeof RECTANGLE | typeof LINE | typeof POLYLINE | null;